import React, { useEffect, useState } from "react";
import { Col, Form, Row, Tab, Tabs} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import Select from "react-select";
import {
    getType,
    toastStyle,
    refreshPage,
    selectDropdownStyle,
    dateFormat,
    getBranchId,
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
// import * as XLSX from "xlsx";

import { getAllBranches } from "../../../Helpers/apiCalls/Manage/Branches";
// import { getAllItems } from "../../../Helpers/apiCalls/itemsApi";
import DeleteModal from "../../../Components/Modals/DeleteModal";
import toast from "react-hot-toast";
import { deleteTransferReceive, searchTransferReceive } from "../../../Helpers/apiCalls/Inventory/TransferApi";
import Footer from "../../../Components/Footer/Footer";
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination";

// NOT USED FOR NOW
export default function TransferReceive() {
    let navigate = useNavigate();
    const accountType = getType();
    const [inactive, setInactive] = useState(true);
    const [filterConfig, setFilterConfig] = useState({
        tab: "for_approval",
        status: "for_approval",
        branch_to: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
        page: 1
    });
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Change this based on your requirement

    const handlePageChange = page => {
        setCurrentPage(page);
        setFilterConfig(prev => ({
        ...prev,
        page: page,
        }));
    };

    const [branches, setBranches] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [tableData, setTableData] = useState([]);
    // const [items, setItems] = useState([]);
    const [isClicked, setIsClicked] = useState(false);
    // const xlsxHeaders =  [ "Total Transfers", "Total Quantity", "Item Name", "Unit", "Quantity", "Branch From", "Branch To" ]
    
    // const [branchFrom, setBranchFrom] = useState("");
    // const [branchTo, setBranchTo] = useState("");
    // const [excelData, setExcelData] = useState([]);


     /* delete modal handler */
     const [showDeleteModal, setShowDeleteModal] = useState(false);
     const handleShowDeleteModal = () => setShowDeleteModal(true);
     const handleCloseDeleteModal = () => setShowDeleteModal(false); 
     const [selectedRow, setSelectedRow] = useState([]);

    // SEARCH USER
    function handleOnSearch(e) {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }

  async function handleSelectChange(e, row) {
    setSelectedRow(row);
    
    if (e.target.value === "view") {
      navigate("/transfer-receive/view/" + row.transfer_id);
    } else if (e.target.value === "edit") {
      navigate("/gatepass/edit/" + row.id);
    } else if (e.target.value === "delete") {
      handleShowDeleteModal();
    }
    
  }

    function ViewBtn(row) {
        return (
            <button
                name="action"
                className="btn btn-sm view-btn-table"
                id={row.id}
                onClick={() => handlePrint(row)}
                // value="payment-pi"
            >
                View
            </button>
        );
    }
    function handlePrint(row) {
        navigate('/transfer-receive/view/' + row.id)
    }


    function ActionBtn(row) {
        //
        return (
        <Form.Select
            name="action"
            className="PO-select-action"
            id={row.id}
            onChange={(e) =>
            handleSelectChange(e, row)
            }
        >
            <option value="" selected hidden>
            Select
            </option>

            <option value="view" className="color-options">
                View
            </option>
            {accountType === "admin" && (
                <option value="delete" className="color-red">
                Delete
                </option>
            )}
        </Form.Select>
        );
    }

    const handleTabSelect = (tabKey) => {
        setCurrentPage(1)
        setFilterConfig((prev) => {
        return {
            ...prev,
            tab: tabKey,
            status: tabKey,
            branch_to: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
            page: 1
        };
        });
    };


    async function fetchBranches() {
        setShowLoader(true);

        const response = await getAllBranches();
        if (response.error) {
        } else {
            var allBranches = response.data.data.data.map((data) => {
                var branch = data;
                branch.label = data.name
                branch.value = data.id
                return branch;
            });
            if(accountType === "branch_oic" || accountType === "branch_inventory_officer") {
                var filteredBranch = allBranches.filter((data) => {
                    return data.id === getBranchId()
                })
                setBranches(filteredBranch);
            } else {
                setBranches([{label: "All Branches", value:""}, ...allBranches]);
            }
        }
        setShowLoader(false);
    }

    async function fetchData() {
        setShowLoader(true);
        setTableData([])
        setTotalItems(0)
        // setExcelData([])
        var allData = [];
        // var allExcel = [];

        const response = await searchTransferReceive(filterConfig);

        if (response.data){
            setTotalItems(response.data.size);
            var allData = response.data.data.map((data) => {
                var info = data;
                info.transfer_date = dateFormat(data.transfer_date)
                info.transfer_receive_date = dateFormat(data.transfer_receive_date)
                allData.push(info);
                return info;
            });

            // var excel = allData.map((data) => {
            //     var info = {};
            //     info.total_transfers = data.total_transfers
            //     info.total_quantity = data.total_quantity
            //     info.name = data.name
            //     info.unit = data.unit
            //     info.total_qty = data.total_qty
            //     info.source_branch = data.source_branch
            //     info.destination_branch = data.destination_branch
            //     allExcel.push(info);
            //     return info;
            // });
        }

        setTableData(allData)
        // setExcelData(allExcel)
        setShowLoader(false);
    }
    
    async function handleDeleteReceive() {
        setIsClicked(true);
       
        const response = await deleteTransferReceive(selectedRow.id);
        if (response.data) {
            toast.success(response.data.message, {
            style: toastStyle(),
            });
            setTimeout(() => {
                refreshPage();
            }, 1000);
        } else {
            response.error?.response?.data?.messages.map((data) => {
                return toast.error(data);
            })
            setTimeout(() => {
                refreshPage();
            }, 1000);
        }
    }

    // function handleExport() {
    //     const rows = excelData
        
    //     /* generate worksheet and workbook */
    //     const worksheet = XLSX.utils.json_to_sheet(rows);
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
    //     XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" });
    //     XLSX.writeFile(workbook, "TransferHistory.xlsx", { compression: true });
    // }

    useEffect(() => {
        fetchBranches();
    }, []);

    useEffect(() => {
        fetchData();
    }, [filterConfig, currentPage]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"TRANSFERS"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> TRANSFER RECEIVE </h1>
                    </Col>
                </Row>

                {/* <Row>
                    <Col className="d-flex justify-content-end mb-3">
                        <div className="d-flex justify-content-end">
                            <button
                                type="button"
                                className="button-primary"
                                onClick={handleExport}
                            >
                                <span className="me-2">
                                    <img
                                        alt="download"
                                        width={20}
                                        height={20}
                                        src={downloadIcon}
                                    ></img>
                                </span>
                                Download
                            </button>
                        </div>
                    </Col>
                </Row> */}

                <Tabs
                    activeKey={filterConfig.tab}
                    defaultActiveKey={filterConfig.tab}
                    id="PO-tabs"
                    onSelect={handleTabSelect}
                >
                    {/* <Tab eventKey="for_approval" title="for approval">

                    </Tab> */}
                    <Tab eventKey="for_approval" title="For Approval">
                        <div className="tab-content">
                        <div className="mb-3" />
                            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                                Filter By:
                            </span>
                            <Row className="PO-filters flex flex-row mx-2 my-1">
                            <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                                <Select
                                    className="dropsearch-filter"
                                    classNamePrefix="react-select"
                                    placeholder="Branch To"
                                    styles={selectDropdownStyle}
                                    // value={branchTo}
                                    options={branches}
                                    onChange={(e) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, branch_to: e.value };
                                        });
                                    }}
                                />
                            </Col>
                            <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                                <Select
                                    className="dropsearch-filter"
                                    classNamePrefix="react-select"
                                    placeholder="Branch From"
                                    styles={selectDropdownStyle}
                                    // value={branchTo}
                                    options={branches}
                                    onChange={(e) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, branch_from: e.value };
                                        });
                                    }}
                                />
                            </Col>
                            <Col xs={6} lg={2}>
                            <DatePicker
                                            autoComplete="off"
                                    selected={filterConfig.date_from}
                                    name="date_from"
                                    placeholderText={"Select Date To"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_from: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="date-filter me-4 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                            </Col>
                            <Col xs={6} lg={2}>
                                <DatePicker
                                            autoComplete="off"
                                    selected={filterConfig.date_to}
                                    name="date_to"
                                    placeholderText={"Select Date From"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_to: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="date-filter ps-label-content me-5 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                            </Col>
                            </Row>
                            <div className="mb-2" />
                            <div className="below">
                                <TableWithDynamicPagination
                                    tableHeaders={[
                                        "-",
                                        "TRANSFER NO.",
                                        // "REQUEST DATE",
                                        "TRANSFER DATE",
                                        "RECEIVED DATE",
                                        "BRANCH FROM",
                                        "BRANCH TO",
                                        "RECEIVED BY",
                                        "RECEIVE NO.",
                                        "ACTIONS",
                                    ]}
                                    headerSelector={[
                                        "-",
                                        "transfer_number",
                                        // "request_date",
                                        "transfer_date",
                                        "transfer_receive_date",
                                        "branch_from_name",
                                        "branch_to_name",
                                        "received_by_name",
                                        "receive_no",
                                    ]}
                                    tableData={tableData}
                                    showLoader={showLoader}
                                    ViewBtn={(row) => ViewBtn(row)}
                                    ActionBtn={(row) => ActionBtn(row)}
                                    // used in dynamic pagination
                                    totalItems={totalItems}
                                    currentPage={currentPage}
                                    itemsPerPage={itemsPerPage}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab>
                    <Tab eventKey="approved" title="received">
                        <div className="tab-content">
                        <div className="mb-3" />
                            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                                Filter By:
                            </span>
                            <Row className="PO-filters flex flex-row mx-2 my-1">
                            <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                                <Select
                                    className="dropsearch-filter"
                                    classNamePrefix="react-select"
                                    placeholder="Branch To"
                                    styles={selectDropdownStyle}
                                    // value={branchTo}
                                    options={branches}
                                    onChange={(e) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, branch_to: e.value };
                                        });
                                    }}
                                />
                            </Col>
                            <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                                <Select
                                    className="dropsearch-filter"
                                    classNamePrefix="react-select"
                                    placeholder="Branch From"
                                    styles={selectDropdownStyle}
                                    // value={branchTo}
                                    options={branches}
                                    onChange={(e) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, branch_from: e.value };
                                        });
                                    }}
                                />
                            </Col>
                            <Col xs={6} lg={2}>
                            <DatePicker
                                            autoComplete="off"
                                    selected={filterConfig.date_from}
                                    name="date_from"
                                    placeholderText={"Select Date To"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_from: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="date-filter me-4 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                            </Col>
                            <Col xs={6} lg={2}>
                                <DatePicker
                                            autoComplete="off"
                                    selected={filterConfig.date_to}
                                    name="date_to"
                                    placeholderText={"Select Date From"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_to: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="date-filter ps-label-content me-5 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                            </Col>
                            </Row>
                            <div className="mb-2" />
                            <div className="below">
                                <TableWithDynamicPagination
                                    tableHeaders={[
                                        "-",
                                        "TRANSFER NO.",
                                        // "REQUEST DATE",
                                        "TRANSFER DATE",
                                        "RECEIVED DATE",
                                        "BRANCH FROM",
                                        "BRANCH TO",
                                        "RECEIVED BY",
                                        "RECEIVE NO.",
                                        "ACTIONS",
                                    ]}
                                    headerSelector={[
                                        "-",
                                        "transfer_number",
                                        // "request_date",
                                        "transfer_date",
                                        "transfer_receive_date",
                                        "branch_form",
                                        "branch_to",
                                        "received_by_name",
                                        "receive_no",
                                    ]}
                                    tableData={tableData}
                                    showLoader={showLoader}
                                    ViewBtn={(row) => ViewBtn(row)}
                                    ActionBtn={(row) => ActionBtn(row)}
                                    // used in dynamic pagination
                                    totalItems={totalItems}
                                    currentPage={currentPage}
                                    itemsPerPage={itemsPerPage}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab>
                    <Tab eventKey="" title="all">
                        <div className="tab-content">
                            <div className="mb-3" />
                            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                                Filter By:
                            </span>
                            <Row className="PO-filters flex flex-row mx-2 my-1">
                            <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                                <Select
                                    className="dropsearch-filter"
                                    classNamePrefix="react-select"
                                    placeholder="Branch To"
                                    styles={selectDropdownStyle}
                                    // value={branchTo}
                                    options={branches}
                                    onChange={(e) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, branch_to: e.value };
                                        });
                                    }}
                                />
                            </Col>
                            <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                                <Select
                                    className="dropsearch-filter"
                                    classNamePrefix="react-select"
                                    placeholder="Branch From"
                                    styles={selectDropdownStyle}
                                    // value={branchTo}
                                    options={branches}
                                    onChange={(e) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, branch_from: e.value };
                                        });
                                    }}
                                />
                            </Col>
                            <Col xs={6} lg={2}>
                            <DatePicker
                                            autoComplete="off"
                                    selected={filterConfig.date_from}
                                    name="date_from"
                                    placeholderText={"Select Date To"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_from: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="date-filter me-4 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                            </Col>
                            <Col xs={6} lg={2}>
                                <DatePicker
                                            autoComplete="off"
                                    selected={filterConfig.date_to}
                                    name="date_to"
                                    placeholderText={"Select Date From"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_to: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="date-filter ps-label-content me-5 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                            </Col>
                            </Row>
                            <div className="mb-2" />
                            <div className="below">
                                <TableWithDynamicPagination
                                    tableHeaders={[
                                        "-",
                                        "TRANSFER NO.",
                                        // "REQUEST DATE",
                                        "TRANSFER DATE",
                                        "RECEIVED DATE",
                                        "BRANCH FROM",
                                        "BRANCH TO",
                                        "RECEIVED BY",
                                        "RECEIVE NO.",
                                        "APPROVED BY",
                                        "ACTIONS",
                                    ]}
                                    headerSelector={[
                                        "-",
                                        "transfer_number",
                                        // "request_date",
                                        "transfer_date",
                                        "transfer_receive_date",
                                        "branch_form",
                                        "branch_to",
                                        "received_by_name",
                                        "receive_no",
                                        "approved_by",
                                    ]}
                                    tableData={tableData}
                                    showLoader={showLoader}
                                    ViewBtn={(row) => ViewBtn(row)}
                                    ActionBtn={(row) => ActionBtn(row)}
                                    // used in dynamic pagination
                                    totalItems={totalItems}
                                    currentPage={currentPage}
                                    itemsPerPage={itemsPerPage}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab>
                    <Tab eventKey="rejected" title="rejected">
                        <div className="tab-content">
                        <div className="mb-3" />
                            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                                Filter By:
                            </span>
                            <Row className="PO-filters flex flex-row mx-2 my-1">
                            <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                                <Select
                                    className="dropsearch-filter"
                                    classNamePrefix="react-select"
                                    placeholder="Branch To"
                                    styles={selectDropdownStyle}
                                    // value={branchTo}
                                    options={branches}
                                    onChange={(e) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, branch_to: e.value };
                                        });
                                    }}
                                />
                            </Col>
                            <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                                <Select
                                    className="dropsearch-filter"
                                    classNamePrefix="react-select"
                                    placeholder="Branch From"
                                    styles={selectDropdownStyle}
                                    // value={branchTo}
                                    options={branches}
                                    onChange={(e) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, branch_from: e.value };
                                        });
                                    }}
                                />
                            </Col>
                            <Col xs={6} lg={2}>
                            <DatePicker
                                            autoComplete="off"
                                    selected={filterConfig.date_from}
                                    name="date_from"
                                    placeholderText={"Select Date To"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_from: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="date-filter me-4 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                            </Col>
                            <Col xs={6} lg={2}>
                                <DatePicker
                                            autoComplete="off"
                                    selected={filterConfig.date_to}
                                    name="date_to"
                                    placeholderText={"Select Date From"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_to: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="date-filter ps-label-content me-5 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                            </Col>
                            </Row>
                            <div className="mb-2" />
                            <div className="below">
                                <TableWithDynamicPagination
                                    tableHeaders={[
                                        "-",
                                        "TRANSFER NO.",
                                        // "REQUEST DATE",
                                        "TRANSFER DATE",
                                        "RECEIVED DATE",
                                        "BRANCH FROM",
                                        "BRANCH TO",
                                        "RECEIVED BY",
                                        "RECEIVE NO.",
                                        "APPROVED BY",
                                        "ACTIONS",
                                    ]}
                                    headerSelector={[
                                        "-",
                                        "transfer_number",
                                        // "request_date",
                                        "transfer_date",
                                        "transfer_receive_date",
                                        "branch_form",
                                        "branch_to",
                                        "received_by_name",
                                        "receive_no",
                                        "approved_by",
                                    ]}
                                    tableData={tableData}
                                    showLoader={showLoader}
                                    ViewBtn={(row) => ViewBtn(row)}
                                    ActionBtn={(row) => ActionBtn(row)}
                                    // used in dynamic pagination
                                    totalItems={totalItems}
                                    currentPage={currentPage}
                                    itemsPerPage={itemsPerPage}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab>
                </Tabs>
            </div>
            <DeleteModal
                show={showDeleteModal}
                onHide={() => handleCloseDeleteModal()}
                text="gatepass"
                onDelete={() => handleDeleteReceive()}
                isClicked={isClicked}
            />
            <Footer/>
        </div>
    );
}
